import { render, staticRenderFns } from "./DocumentsLmListV1.vue?vue&type=template&id=1241e351&scoped=true&"
import script from "./DocumentsLmListV1.vue?vue&type=script&lang=js&"
export * from "./DocumentsLmListV1.vue?vue&type=script&lang=js&"
import style0 from "./DocumentsLmListV1.vue?vue&type=style&index=0&id=1241e351&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1241e351",
  null
  
)

export default component.exports